<div class="dark-table-wrapper">
    <!-- Search Bar -->
    <div class="search-container" *ngIf="showSearchBar">
        <div class="search-input-wrapper">
            <i class="fas fa-search search-icon"></i>
            <input type="text" class="search-input" [(ngModel)]="searchTerm" (input)="filterData($event, 'contains')"
                placeholder="Search documents...">
        </div>
    </div>

    <!-- Dark Themed Table -->
    <div class="dark-table-container">
        <p-table #dt [columns]="columnDefs" [value]="dataCopy" [resizableColumns]="true" columnResizeMode="fit"
            [scrollable]="false" scrollHeight="flex">

            <!-- Header Template -->
            <ng-template pTemplate="header" let-columns>
                <tr class="dark-table-header-row">
                    @for (column of columns; track column) {
                    @if(!column.field?.toLowerCase().endsWith("_copy")){
                    @if (column?.columnType == 'checkbox') {
                    <th class="dark-table-header-cell">
                        <p-checkbox [(ngModel)]="allSelected" [binary]="true" (onChange)="toggleSelectAll($event)">
                        </p-checkbox>
                    </th>
                    } @else if (column?.columnType == 'radio') {
                    <th class="dark-table-header-cell"></th>
                    } @else if (column?.columnType === 'phone' && !showContactColumn) {
                    <!-- Skip rendering this column -->
                    } @else {
                    <th pSortableColumn="{{column.field}}" class="dark-table-header-cell"
                        [ngStyle]="{'width': column?.config?.width, 'min-width': column?.config?.minWidth}">
                        {{ column.header }}
                        @if(!(column.header === 'Actions')){
                        <p-sortIcon field="{{column.field}}" />
                        }
                    </th>
                    }
                    }
                    }
                </tr>
            </ng-template>

            <!-- Body Template -->
            <ng-template pTemplate="body" let-currentRow let-columns="columns">
                <tr class="dark-table-body-row" [ngStyle]="getRowStyle(currentRow.id)">
                    @for (col of columns; track $index) {
                    @if(!col.field?.toLowerCase().endsWith("_copy")){
                    @if(col?.columnType === 'fileIcon') {
                    <td class="dark-table-cell file-icon-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}">
                        <i [class]="'fas ' + getFileIcon(currentRow[col?.field])"
                            [pTooltip]="getTooltipText(col, currentRow)" appendTo="body"
                            [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                            [showDelay]="col?.tooltipConfig?.showDelay || 300"
                            [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                            [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'"></i>
                    </td>
                    } @else if(col?.columnType === 'dropdown'){
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}">
                        <p-dropdown [options]="filterOptions(col?.options,currentRow['allocationType'],currentRow)"
                            appendTo="body" panelStyleClass="custom-dark-dropdown-panel" scrollHeight="150px"
                            [ngClass]="col?.header === 'Name' ? {'custom-dark-dropdown':false} : {'custom-dark-dropdown':true}"
                            [(ngModel)]="currentRow[col?.field]" [autoDisplay]="true" [(ngModel)]="selectedAction"
                            (onChange)="onDropdownClick($event, currentRow, col?.options)">
                            <ng-template let-option pTemplate="item">
                                <span>{{ option.label }}</span>
                            </ng-template>
                        </p-dropdown>
                    </td>
                    } @else if (col?.columnType === 'checkbox') {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}">
                        <p-checkbox [binary]="true" [(ngModel)]="currentRow['selection']"
                            (onChange)="onCheckboxChange($event, currentRow)">
                        </p-checkbox>
                    </td>
                    } @else if (col?.columnType === 'radio') {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}">
                        <p-radioButton name="radiobutton" [value]="currentRow" [(ngModel)]="selectedItem"
                            (onClick)="onRadioChange($event, currentRow)">
                        </p-radioButton>
                    </td>
                    } @else if (col?.columnType === 'hyperlink') {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}">
                        <a class="dark-hyperlink" [routerLink]="col.route ? [col.route, currentRow.id] : null"
                            (click)="handleHyperlinkClick($event, col, currentRow)"
                            [pTooltip]="getTooltipText(col, currentRow)"
                            [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                            [showDelay]="col?.tooltipConfig?.showDelay || 300"
                            [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                            [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'">
                            {{ setTextLength(currentRow[col?.field], 20) }}
                        </a>
                    </td>
                    } @else if (col?.columnType === 'phone' && showContactColumn) {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}"
                        [pTooltip]="getTooltipText(col, currentRow)"
                        [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                        [showDelay]="col?.tooltipConfig?.showDelay || 300"
                        [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                        [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'">
                        <div class="phone-cell" style="display: flex; justify-content: center; align-items: center;">
                            @if(showCallIcon) {
                            <i class="fas fa-phone phone-icon"
                                (click)="onClickEyeOfContactColumn(currentRow[col?.field])" title="View and call"
                                style="cursor: pointer; color: var(--accent-teal);">
                            </i>
                            }
                        </div>
                    </td>
                    } @else if (col?.columnType === 'date') {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}"
                        [pTooltip]="getTooltipText(col, currentRow)"
                        [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                        [showDelay]="col?.tooltipConfig?.showDelay || 300"
                        [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                        [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'">
                        @if(col?.config?.isUnixTime){
                        {{ currentRow[col?.field] *1000 | date:col?.config?.dateFormat }}
                        }
                        @else {
                        {{ currentRow[col?.field] | date:col?.config?.dateFormat }}
                        }
                    </td>
                    } @else if (col?.columnType === 'badge') {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}"
                        [pTooltip]="getTooltipText(col, currentRow)"
                        [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                        [showDelay]="col?.tooltipConfig?.showDelay || 300"
                        [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                        [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'">
                        <div class="badge-cell" [class]="'badge-' + getBadgeConfig(col, currentRow).color">
                            <i [class]="'fas ' + getBadgeConfig(col, currentRow).icon"></i>
                            <span>{{ getBadgeConfig(col, currentRow).label }}</span>
                        </div>
                    </td>
                    } @else if (col?.columnType === 'icon') {
                    <td class="dark-table-cell icon-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}"
                        [pTooltip]="getTooltipText(col, currentRow)"
                        [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                        [showDelay]="col?.tooltipConfig?.showDelay || 300"
                        [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                        [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'">
                        <div class="icon-wrapper">
                            @if (col?.config?.icons) {
                                @for (iconConfig of col?.config?.icons; track $index) {
                                @if(iconConfig.isImage) {
                                <button class="icon-action-btn" [class]="'icon-' + iconConfig.name"
                                    [pTooltip]="iconConfig.tooltip" tooltipPosition="top" [showDelay]="300" [hideDelay]="100" tooltipStyleClass="yellow-tooltip" (click)="onIconClick(iconConfig.name, currentRow)">
                                    <img [src]="iconConfig.icon" [alt]="iconConfig.name" class="icon-image">
                                </button>
                                } @else {
                                <button class="icon-action-btn" [class]="'icon-' + iconConfig.name"
                                    [pTooltip]="iconConfig.tooltip" tooltipPosition="top" [showDelay]="300" [hideDelay]="100" tooltipStyleClass="yellow-tooltip" (click)="onIconClick(iconConfig.name, currentRow)">
                                    <i [class]="'fas ' + iconConfig.icon"></i>
                                </button>
                                }
                                }
                            } @else if (currentRow[col?.field]) {
                                @for (imgInfo of currentRow[col?.field]; track $index) {
                                <button class="icon-action-btn" style="background:none;border:none;padding:0;" [pTooltip]="imgInfo?.name" tooltipPosition="top" [showDelay]="300" [hideDelay]="100" tooltipStyleClass="yellow-tooltip" (click)="onIconClick(imgInfo.name, currentRow)">
                                    <img [src]="imgInfo.imgSrc" [style]="{width: imgInfo.size, margin: imgInfo.margin}"
                                        class="text-center icon-image" [alt]="imgInfo?.name">
                                </button>
                                }
                            }
                        </div>
                    </td>
                    } @else if (col?.columnType === 'input') {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}"
                        [pTooltip]="getTooltipText(col, currentRow)"
                        [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                        [showDelay]="col?.tooltipConfig?.showDelay || 300"
                        [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                        [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'">
                        <input [type]="col.inputType || 'text'" class="dark-table-input"
                            [(ngModel)]="currentRow[col?.field]" [disabled]="false">
                    </td>
                    } @else if (col?.columnType === 'amount') {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}"
                        [pTooltip]="getTooltipText(col, currentRow)"
                        [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                        [showDelay]="col?.tooltipConfig?.showDelay || 300"
                        [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                        [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'">
                        {{ currentRow[col?.field] | indianCurrency : col?.config?.decimals != undefined ?
                        col?.config?.decimals : 0 }}
                    </td>
                    } @else {
                    <td class="dark-table-cell"
                        [ngStyle]="{'width': col?.config?.width, 'min-width': col?.config?.minWidth}"
                        [pTooltip]="getTooltipText(col, currentRow)"
                        [tooltipPosition]="col?.tooltipConfig?.position || 'top'"
                        [showDelay]="col?.tooltipConfig?.showDelay || 300"
                        [hideDelay]="col?.tooltipConfig?.hideDelay || 100"
                        [tooltipStyleClass]="col?.tooltipConfig?.fontColor ? '' : 'yellow-tooltip'">
                        {{ setTextLength(currentRow[col?.field], 50) }}
                    </td>
                    }
                    }
                    }
                </tr>
            </ng-template>

            <!-- Empty Template -->
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="columnDefs?.length || 0" class="dark-table-no-record">
                        <span class="no-record-text">No documents found</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- Contact Modal -->
<div class="contact-modal-overlay" *ngIf="viewContactModal" (click)="viewContactModal = false">
    <div class="contact-modal" (click)="$event.stopPropagation()">
        <div class="contact-modal-header">
            <h3>Call Details</h3>
            <button class="close-button" (click)="viewContactModal = false">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div class="contact-modal-body">
            <p><strong>Contact Number:</strong> {{ viewedContactNumber }}</p>
            <p><strong>Your Number:</strong> {{ currentUserContactNumber }}</p>
        </div>
        <div class="contact-modal-footer">
            <button class="btn-call" (click)="clickToCall($event)">
                <i class="fas fa-phone"></i> Start Call
            </button>
        </div>
    </div>
</div>